<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="row">
        <h5 *ngIf="appraisal.id; else titleBlock" class="modal-title container"
          i18n>Editar Certificado de Aferição</h5>
        <ng-template #titleBlock>
          <h5 class="modal-title container" i18n>Novo Certificado de
            Aferição</h5>
        </ng-template>
      </div>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <div class="loading-page" *ngIf="loading">
        <div class="loading-spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
      <form [formGroup]="appraisalForm" (submit)="onSubmit()" *ngIf="!loading">
        <div class="row mb-3">
          <div class="col-12 col-md-5">
            <div class="form-group">
              <app-input i18n-label="@@ContractLabel"
                [type]="appraisal && appraisal.id ? 'text' : 'select'"
                formControlName="contractId" inputRequired=true label="Contrato"
                [inputDisabled]="appraisal?.id"
                [list]="contracts" i18n-placeholder
                placeholder="Selecione o Contrato" selectValue="id"
                selectText="prettyName"
                (ngModelChange)="filterContract($event)">
              </app-input>
            </div>
          </div>

          <div class="col-12 col-md-5">
            <div class="form-group">
              <app-input i18n-label="@@UserLabel" type="select"
                formControlName="technicianUserId" inputRequired=true
                label="Executor dos Ensaios" [list]="users" i18n-placeholder
                placeholder="Selecione o Usuario" [(ngModel)]="technicianUserId"
                selectValue="id" selectText="name">
              </app-input>
            </div>
          </div>
          <div class="col-12 col-md-2">
            <div *ngIf="appraisal?.id" class="form-group">
              <app-input type="text" [isLabel]="true" i18n-label="@@"
                label="Código de Ensaio "></app-input>
              <strong>CE {{appraisal.experimentCode}}</strong>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 col-md-3">
            <div class="form-group" style>
              <label i18n>Data do Ensaio<small
                  class="text-danger">*</small></label>
              <app-input type="date" class="no-margin small"
                formControlName="experimentDate" inputRequired=true
                hasLabel=false>
              </app-input>
            </div>
          </div>
          <div class="col-12 col-md-2"></div>
          <div class="col-12 col-md-3">
            <div class="form-group" style>
              <label i18n>Validade da Verificação Inicial<small
                  class="text-danger">*</small></label>
              <app-input type="date" class="no-margin small"
                formControlName="validateInitial" inputRequired=true
                hasLabel=false>
              </app-input>
            </div>
          </div>
          <div class="col-12 col-md-4"></div>
        </div>
        <hr>
        <section>
          <div [id]="'userIdHistoryUnfoldEquipment'">
            <!-- Equipments -->
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreOrLessEquipment()">
                  <h5 class="mb-3" i18n><strong>Equipamento</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreOrLessEquipment()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldEquipment === 'less'; else elseBlockTable">unfold_less</i>
                    <ng-template #elseBlockTable>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldEquipment === 'more'"
                class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-12 col-md-3">
                        <app-input *ngIf="!appraisal?.id" i18n-label="@@EquipmentLabel" type="select"
                          formControlName="equipmentId"
                          inputRequired=true label="Nº de Série"
                          [list]="equipments"
                          i18n-placeholder placeholder="Selecione o Equipamento"
                          selectValue="id" selectText="serialNumber"
                          (ngModelChange)="filterEquipment($event)">
                        </app-input>
                        <app-input *ngIf="appraisal?.id" type="text"
                          label="Nº de Série"
                          formControlName="serialNumber"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input i18n-label type="text" label="Fabricante"
                          formControlName="manufacturerName"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input i18n-label type="text" label="Modelo"
                          formControlName="equipmentModelName"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                      <div class="col-12 col-md-3">
                        <app-input i18n-label type="text" label="Instrumento"
                          formControlName="equipmentModelInstrument"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <app-input i18n-label type="text"
                            label="Lacres Principais"
                            formControlName="mainSeals"
                            inputRequired=true>
                          </app-input>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label i18n>Lacres Secundários</label>
                          <textarea class="form-control" rows="5"
                            formControlName="secondarySeals"
                            readonly></textarea>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="equipmentModelCategory==='noIntrusive'">
                      <div class="row mb-3">
                        <div class="col-12 col-md-3">
                          <div class="col-12">
                            <label i18n>Sensor</label>
                            <br />
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <app-input i18n-label type="text"
                              label="Nº de Série"
                              formControlName="additionalSerialNumber"
                              [inputDisabled]="true">
                            </app-input>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <app-input i18n-label type="text"
                              label="Lacres Principais"
                              formControlName="additionalMainSeals"
                              inputRequired=true>
                            </app-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr>
        <div class="row mb-3">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <app-input i18n-label type="text"
                label="Nº de Portaria de Aprovação"
                formControlName="ordinanceApproveNumber" [inputDisabled]="true">
              </app-input>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <app-input i18n-label type="text" label="Código do Serviço"
                formControlName="serviceCode"
                [inputDisabled]="true">
              </app-input>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <app-input i18n-label type="text" label="Valor"
                formControlName="value" [inputDisabled]="true">
              </app-input>
            </div>
          </div>
        </div>
        <hr>
        <section>
          <div [id]="'userIdHistoryUnfoldLocal'">
            <!-- Local -->
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreOrLessLocal()">
                  <h5 class="mb-3" i18n><strong>Local</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreOrLessLocal()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldLocal === 'less'; else elseBlockTable">unfold_less</i>
                    <ng-template #elseBlockTable>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldLocal === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="row mb-3">
                    <div class="col-12 col-md-8">
                      <div class="form-group">
                        <app-input i18n-label type="select" [list]="spots"
                          label="Ponto" formControlName="spotId"
                          selectText="prettyName" selectValue="id"
                          selectShowLimit="2" placeholder="Selecione o Ponto"
                          i18n-placeholder (ngModelChange)="setLanes($event)">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <app-input i18n-label type="select" [list]="lanes"
                          label="Faixa" formControlName="laneId"
                          selectText="prettyNames" selectValue="id"
                          selectShowLimit="2" placeholder="Selecione a Faixa"
                          i18n-placeholder (ngModelChange)="setLane($event)">
                        </app-input>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Descrição"
                          formControlName="laneDescription"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Sentido"
                          formControlName="laneDirection"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <app-input i18n-label type="text"
                          label="Velocidade da Via"
                          formControlName="laneSpeedsRegularVehicles"
                          [inputDisabled]="true">
                        </app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [id]="'userIdHistoryUnfoldCompanyManufacturer'">
            <!-- CompanyManufacturers -->
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreOrLessCompanyManufacturer()">
                  <h5 class="mb-3" i18n><strong>Nome/Razão Social Detentor do
                      Equipamento</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreOrLessCompanyManufacturer()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldCompanyManufacturer === 'less'; else elseBlockTable">unfold_less</i>
                    <ng-template #elseBlockTable>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldCompanyManufacturer === 'more'"
                class="limited-height">
                <div class="card card-body">
                  <div class="row mb-3">
                    <div class="col-12 col-md-8">
                      <div class="form-group">
                        <app-input type="select" [list]="companies"
                          label="Empresa"
                          formControlName="manufacturerCompanyId"
                          selectText="name" selectValue="id"
                          placeholder="Selecione uma empresa" i18n-placeholder
                          inputRequired=true i18n-label>
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="CNPJ"
                          [inputDisabled]="true"
                          formControlName="manufacturerCompanyCnpj">
                        </app-input>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Endereço"
                          [inputDisabled]="true"
                          formControlName="manufacturerCompanyAdress">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="CEP"
                          [inputDisabled]="true"
                          formControlName="manufacturerCompanyZipcode">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Bairro"
                          [inputDisabled]="true"
                          formControlName="manufacturerCompanyNeighbor">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Município-UF"
                          [inputDisabled]="true"
                          formControlName="manufacturerCompanyCity">
                        </app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [id]="'userIdHistoryUnfoldCompanyResponsible'">
            <!-- CompanyResponsibles -->
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreOrLessCompanyResponsible()">
                  <h5 class="mb-3" i18n><strong>Nome/Razão Social Fabricante do
                      Equipamento</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreOrLessCompanyResponsible()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldCompanyResponsible === 'less'; else elseBlockTable">unfold_less</i>
                    <ng-template #elseBlockTable>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldCompanyResponsible === 'more'"
                class="limited-height">
                <div class="card card-body">
                  <div class="row mb-3">
                    <div class="col-12 col-md-8">
                      <div class="form-group">
                        <app-input type="select" [list]="companies"
                          label="Empresa" formControlName="responsibleCompanyId"
                          selectText="name" selectValue="id"
                          placeholder="Selecione uma Empresa" i18n-placeholder
                          inputRequired=true i18n-label>
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="CNPJ"
                          [inputDisabled]="true"
                          formControlName="responsibleCompanyCnpj">
                        </app-input>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Endereço"
                          [inputDisabled]="true"
                          formControlName="responsibleCompanyAdress">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="CEP"
                          [inputDisabled]="true"
                          formControlName="responsibleCompanyZipcode">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Bairro"
                          [inputDisabled]="true"
                          formControlName="responsibleCompanyNeighbor">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <app-input i18n-label type="text" label="Município-UF"
                          [inputDisabled]="true"
                          formControlName="responsibleCompanyCity">
                        </app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [id]="'userIdUnfoldAssign'">
            <!-- CompanyResponsibles -->
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreOrLessAssign()">
                  <h5 class="mb-3" i18n><strong>Assinaturas</strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreOrLessAssign()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldAssign === 'less'; else elseBlockTable">unfold_less</i>
                    <ng-template #elseBlockTable>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldAssign === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="row mb-3">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <app-input i18n-label="@@UserLabel" type="select"
                          formControlName="technicianUserId"
                          label="Executor dos Ensaios" [list]="users"
                          i18n-placeholder [(ngModel)]="technicianUserId"
                          placeholder="Selecione o Usuario" selectValue="id"
                          selectText="name" [inputDisabled]="true">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <app-input i18n-label="@@UserLabel" type="select"
                          formControlName="representativeUserId"
                          label="Representante Legal" [list]="users"
                          i18n-placeholder inputRequired=true
                          placeholder="Selecione o Usuario" selectValue="id"
                          selectText="name">
                        </app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="onCancel()">
        <app-loading [promise]="promise" text="Cancelar"
          i18n-text></app-loading>
      </button>
      <button class="btn btn-primary" (click)="onSubmit()"
        [ngClass]="{'disabled': !isValid}">
        <app-loading [promise]="promise" text="Confirmar"
          i18n-text></app-loading>
      </button>
    </div>
  </div>
</div>
